<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName">
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div v-if="tab == 'summary' && selectedSummaryType != 'date'">
            <div class="row mb-2">
                <div class="col-sm-12 col-md-12 mb-2">
                    <div class="dataTables_filter">
                        <label class="d-flex mb-0">
                            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchVoucher" @keypress.enter="filterSearchVoucher">
                            <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchVoucher()">
                                <i class="fas fa-search"></i>
                            </button>
                        </label>
                    </div>
                </div>
                <div class="col-sm-12 col-md-5">
                    <date-range-picker class="w-100"
                        :minDate="minDate"
                        :class="dateDisabled ? 'date-balance-disabled' : ''"
                        ref="picker"
                        v-model="dateBalance"
                        :opens="'right'"
                        :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                        :autoApply="true"
                        :showDropdowns="true" 
                        :always-show-calendars="true"
                        :single-date-picker="true"
                        :ranges="false"
                        :disabled="dateDisabled"
                        @showCustomRange="showCustomRangeCalendars=true"
                        @update="filterByEndDate">
                    </date-range-picker>
                </div>
                
                <div class="col-sm-12 col-md-2 d-flex align-self-center"> 
                    <div class="custom-control custom-checkbox mb-2">
                        <input type="checkbox" class="custom-control-input" id="showExpiry" v-model="selectedDateFilter">
                        <label class="custom-control-label" for="showExpiry">{{$t('label.filter_by_expiry_date')}}</label>
                    </div>
                </div>
                <div v-show="selectedDateFilter" class="col-sm-12 col-md-5">
                    <date-range-picker class="w-100 mb-2"
                        :minDate="minDate"
                        ref="picker"
                        v-model="dateRange"
                        :opens="'right'"
                        :autoApply="true"
                        :showDropdowns="true" 
                        :always-show-calendars="false"
                        :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                        @showCustomRange="showCustomRangeCalendars=true"
                        @update="filterByDate">
                    </date-range-picker>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="tab == 'list'" class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="dataTables_filter mb-2">
                        <label class="form-label">{{$t('label.voucher_name')}}</label>
                        <label class="d-flex mb-0">
                            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search') + $t('label.voucher_name')" v-model="searchVoucher" @keypress.enter="filterSearchVoucher">
                            <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchVoucher()">
                                <i class="fas fa-search"></i>
                            </button>
                        </label>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="dataTables_filter mb-2">
                        <label class="form-label">{{$t('label.customer_name')}}</label>
                        <label class="d-flex mb-0">
                            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"  :placeholder="$t('label.search') + $t('label.customer_name')" v-model="searchCustomer" @keypress.enter="filterSearchCustomer">
                            <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchCustomer()">
                                <i class="fas fa-search"></i>
                            </button>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6"> 
                    <date-range-picker class="w-100 mb-2"
                        :minDate="minDate"
                        ref="picker"
                        v-model="dateRange"
                        :opens="'right'"
                        :autoApply="true"
                        :showDropdowns="true" 
                        :always-show-calendars="false"
                        :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                        @showCustomRange="showCustomRangeCalendars=true"
                        @update="filterByDate">
                    </date-range-picker>
                </div>
                <div class="mb-2 col-sm-12 col-md-6">
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0" >
                                    <i class="fas fa-store"></i>
                                </label>
                                <multiselect :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                    <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="link text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
        <ul v-if="tab == 'summary'" class="nav nav-tabs mt-2" role="tablist">
            <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.reportVoucherSummaryType" :key="c.id">
                <a :class="{'active': selectedSummaryType == c.id}" class="nav-link" role="tab" @click="filterByType(c.id)">{{c.text}}</a>
            </li>
        </ul>
        <ul v-else class="nav nav-tabs mt-2" role="tablist">
            <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.reportVoucherListType" :key="c.id">
                <a :class="{'active': selectedListType == c.id}" class="nav-link" role="tab" @click="filterByType(c.id)">{{c.text}}</a>
            </li>
        </ul>
    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: "voucherFilter",
    components:{
        DateRangePicker
    },
    data(){
        let startDate = moment().startOf('day');
        let endDate = moment().endOf('day');
        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            tab: "summary",
            selectedDateFilter: false,
            selectedSummaryType: "customer",
             selectedListType: "signup",
            searchVoucher: "", searchCustomer: "",
            dateRange: { startDate, endDate }, date: "",
            dateBalance: {startDate},
            outlet: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}],
            selectedOutlet: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})},
            dateFilter: "", searchFilter: "", typeFilter: "",
            exportHeaders: [], exportFields: {}, exportData: [], exportFileName: "",

            dateDisabled: false,
        }
    },
    watch:{
        selectedDateFilter(value){
            if(!value){
                this.filterVoucherItem();
            }
        },
        "$i18n.locale"(val){
            this.outlet = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj=> obj.id == b.id)[0]
        }
    },
    methods:{
        clearFilter(){
            if(this.tab == 'summary' && this.selectedSummaryType == 'customer'){
                this.searchVoucher = ""
                var data = {
                    dateBalance: this.dateBalance,
                    date: this.dateRange,
                    searchVoucher: this.searchVoucher,
                    searchCustomer: this.searchCustomer,
                    listType: this.selectedListType, 
                    summaryType: this.selectedSummaryType
                }
                this.$emit('setCreditBalance', data)

            }else{
                let startDate = moment().startOf('day');
                let endDate = moment().endOf('day');

                this.dateRange = {startDate, endDate}
                this.searchVoucher = this.searchCustomer = ""
                this.selectedListType = "signup"
                this.selectedSummaryType = "customer"
                this.selectedOutlet = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}
                this.filterVoucherItem();
            }
            
        },
        filterSearchVoucher(){
            this.filterVoucherItem();
        },
        filterSearchCustomer(){
            this.filterVoucherItem();
        },
        filterByEndDate(date){
            this.dateBalance = date
            this.filterVoucherItem();
        },
        filterByDate(date){
            date.startDate = moment(date.startDate).startOf('day')
            date.endDate = moment(date.endDate).endOf('day')
            this.dateRange = date
            this.filterVoucherItem();
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.filterVoucherItem();
        },
        filterByType(type){
            this.dateDisabled = false
            
            if(this.tab == 'list'){
                this.selectedListType = type;
            }else{
                this.selectedSummaryType = type
                if(type === 'expiry') {
                    // this.dateBalance = { startDate: moment().startOf('day'), endDate: moment().endOf('day') }
                    // this.dateDisabled = true
                }
            } 
            this.filterVoucherItem()
        },
        filterVoucherItem(){
            var filterObj = {
                dateBalance: this.dateBalance,
                dateFilter: this.selectedDateFilter,
                date: this.dateRange,
                searchVoucher: this.searchVoucher,
                searchCustomer: this.searchCustomer,
                listType: this.selectedListType,
                summaryType: this.selectedSummaryType,
                outletID: this.selectedOutlet.id,
            }
            this.tab == 'summary' ? this.$emit('filterCreditSummary', filterObj) : this.$emit('filterCreditList', filterObj);
        },
        updateSummaryType(tab){
            this.tab = tab;
            if(tab == 'summary'){
                this.selectedSummaryType = 'customer'
                this.filterByType(this.selectedSummaryType);
            }else{
                this.selectedListType = 'signup'
                this.filterByType(this.selectedListType);
            }
        }, 
        setExportData(data){
            this.exportData = data.data
            this.exportFields = data.fields
            this.exportHeaders = data.headers
            this.exportFileName = data.fileName
        }
    },
    mounted(){
        let $vm = this;
        var outlets = JSON.parse($vm.$store.state.outlets);
        $vm.outlet.push(...outlets);

        if (this.outlet[1]) {
            this.selectedOutlet = this.outlet[1]
        }

        $vm.filterVoucherItem();
    }
}
</script>
<style scoped>
.link, .nav-link{
    cursor: pointer;
}
</style>